import { render, staticRenderFns } from "./DiseasesList.vue?vue&type=template&id=06820e4a&scoped=true"
import script from "./DiseasesList.vue?vue&type=script&lang=js"
export * from "./DiseasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06820e4a",
  null
  
)

export default component.exports